import React, { useEffect } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import { FaBox, FaMoneyBillWave, FaShieldAlt, FaCircle } from 'react-icons/fa';
import { COLORS } from '../constants/colors';

function SellerInfoScreen() {
    const copper = COLORS.COPPER;
    const sageGreen = COLORS.SAGE_GREEN;
    const plum = COLORS.PLUM;
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const InfoCard = ({ icon, title, children }) => (
        <Card className="h-100 border-0 shadow-sm hover-shadow">
            <Card.Body className="p-4">
                <div className="text-center mb-4">
                    <div className="rounded-circle bg-light d-inline-flex p-3">
                        {icon}
                    </div>
                </div>
                <Card.Title className="text-center h5 mb-3" style={{ color: plum }}>{title}</Card.Title>
                <Card.Text className="text-muted">
                    {children}
                </Card.Text>
            </Card.Body>
        </Card>
    );

    return (
        <div className="bg-light min-vh-100 py-5">
            <Container>
                {/* Hero Section */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold mb-3" style={{ color: plum }}>
                            Seller Information
                        </h1>
                        <p className="lead" style={{ color: copper }}>
                            Everything you need to know about selling on our platform
                        </p>
                    </Col>
                </Row>

                {/* Main Content */}
                <Row className="g-4 mb-5">
                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaBox size={24} color={sageGreen} />}
                            title="Listing Requirements"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> High-quality photos</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Ring number, letters, year and country</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Detailed Pedigree</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Additional breeding information</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Video or Video links</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaMoneyBillWave size={24} color={sageGreen} />}
                            title="Commission Structure"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> <s>10% commission</s> <strong>7.5% commission for 2025</strong></li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> No bids incur commission charge on Start Bid Price</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Payment on 7 days for paidup bids less commission</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> No bid items can be relisted once at no extra charge</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaShieldAlt size={24} color={sageGreen} />}
                            title="Seller Protection"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure site and payments</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Dispute resolution</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Fraud prevention</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Support team</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default SellerInfoScreen;
